__turbopack_context__.v({
  "button": "fimYnq_button",
  "checkboxText": "fimYnq_checkboxText",
  "content": "fimYnq_content",
  "description": "fimYnq_description",
  "divider": "fimYnq_divider",
  "link": "fimYnq_link",
  "popup": "fimYnq_popup",
  "title": "fimYnq_title",
});
